import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  MinusInCircleIcon,
  PlusInCircleIcon,
  Button,
  MinusInCircleRedIcon,
  PlusInCircleRedIcon,
} from 'components';
import { withToggle } from 'utils/HOC/withToggle.hoc';
import SlashInCircle from 'components/SvgIcons/ComplexIcons/slash-in-circle.svg';

@withToggle({ urlParamName: 'togglePanel', defaultState: true })
export class TogglePanel extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    titleWithSlash: PropTypes.string,
    className: PropTypes.string,
    sizeIcon: PropTypes.string,
    // start toggle props
    isShowData: PropTypes.bool,
    toggleShow: PropTypes.func,
    // end toggle props
  };

  render() {
    const {
      children,
      isShowData,
      toggleShow,
      title,
      className,
      sizeIcon,
      titleWithSlash,
    } = this.props;

    return (
      <div className={className}>
        <div className="flex justify-content-space-between">
          {title && <h2 className="montserrat bold fs-24">{title}</h2>}
          {titleWithSlash && (
            <div className="flex align-items-center">
              <SlashInCircle className="mr-2" width={23} height={23} />
              <h3 style={{ flex: 1 }}>{titleWithSlash}</h3>
            </div>
          )}
          <Button
            className="_simple-red ml-5"
            onClick={toggleShow}
            style={{ height: 'auto' }}
          >
            {isShowData ? (
              sizeIcon ? (
                <MinusInCircleRedIcon />
              ) : (
                <MinusInCircleIcon width="24px" height="24px" />
              )
            ) : sizeIcon ? (
              <PlusInCircleRedIcon />
            ) : (
              <PlusInCircleIcon width="24px" height="24px" />
            )}
          </Button>
        </div>
        <div className={isShowData ? 'block' : 'none'}>{children}</div>
      </div>
    );
  }
}
